export default __webpack_public_path__ + "static/media/handsome.f15ab422.png";